import { useState, useEffect } from 'react';
import { experienceService } from '../services/dataService';

/**
 * Custom hook to fetch experience data from Firestore
 * @returns {Object} { experience, loading, error, refetch }
 */
export const useExperience = () => {
  const [experience, setExperience] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchExperience = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const result = await experienceService.getAll();
      
      if (result.success) {
        // Sort by order field
        const sortedExperience = result.data.sort((a, b) => (a.order || 0) - (b.order || 0));
        setExperience(sortedExperience);
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchExperience();
  }, []);

  return {
    experience,
    loading,
    error,
    refetch: fetchExperience
  };
};